function QuestionsCard({ res }) {
  return <div className="step-card-title">{res.QuestionText}</div>;
}

export default QuestionsCard;
